import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { GradientLoader } from "./commonComponents";

export function ProtectedRoute(props) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <GradientLoader/>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return <>{props.children}</>;
}

export default ProtectedRoute;